import React, { Component } from 'react';
import DesktopLogo from '../images/HeroBanner/LogoClpDesktop.svg';
import playStoreLogo from '../images/HeroBanner/PlayStore.svg';
import '../css/SgCampaign.css';
import menuMobile from '../images/HeroBanner/menuMobile.svg';
import closeMenuMobile from '../images/HeroBanner/closeMenuMobile.svg';
import PlayStoreMobile from '../images/HeroBanner/PlayStoreMobile.svg';
// import { withRouter } from 'react-router-dom';
import phoneIcon from "../images/HeroBanner/phoneIcon.svg"
import SmartPhone from "../images/HeroBanner/smartphone.svg"
import logo from "../images/logo.svg"

class NavBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMenuClick: false
		};
	}

	handleMenu = () => {
		let { isMenuClick } = this.state;
		this.setState({ isMenuClick: !isMenuClick });
	};


	render() {
		let { isMenuClick } = this.state;
		return (
			<div className="navigationbar">
				<div
					className="navigationbarSub"
					style={{ flexDirection: isMenuClick || window.screen.width < 700 ? 'column' : 'row' }}
				>
					<div className="navigationbar_head">
						<div className="navigationbarLogo">
							<img
								onClick={() => {
									// this.props.history.push('/');
									window.location.href = "/"
								}}
								alt=""
								src={window.screen.width > 700 ? DesktopLogo : logo}
								className="navigationbarLogoImg"
							/>
						</div>
						{window.screen.width > 700 ? (
							<div className="navigationbarMenu">
								<a href="tel:9090404009"
									className="navigationbarBtn"
								>
									<img src={phoneIcon} alt="" />9090404009
								</a>
							</div>
						) : (
								<div className="navigationbarMenu">
									<a href="tel:9090404009"
									className="navigationbarBtn2"
								>
									Sales:{" "}{" "} <img src={SmartPhone} alt="" style={{margin: '0px 2px'}}/>{" "}9090404009
								</a>
								</div>
							)}
					</div>
					{/* {isMenuClick ? (
						<div className="navigationMobileOptions">

							<a href="tel:9090404009" className="navigationMobilePhoneBtn" >
								<img src={phoneIconMobile} alt="" />
								9090404009
								</a>

						</div>
					) : (
							''
						)} */}
				</div>
			</div>
		);
	}
}

export default NavBar;
